import type { CSSProperties } from 'react'

import { appName } from '@/lib/shared'

type WordmarkProps = {
  className?: string
  style?: CSSProperties
}

/**
 * Text wordmark. Keep this as real text so the logo cannot pick up
 * image/SVG artifacts.
 */
const Wordmark: React.FC<WordmarkProps> = ({ className, style }) => (
  <span
    className={className}
    style={{
      color: 'var(--color-fd-foreground)',
      fontFamily: 'var(--font-heading), var(--font-sans), sans-serif',
      fontWeight: 600,
      letterSpacing: 0,
      lineHeight: 1,
      ...style,
    }}
  >
    {appName}
  </span>
)

export default Wordmark
